if (!customElements.get('evrayne-buy-bar')) {
  customElements.define('evrayne-buy-bar', class extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.main = this.form?.querySelector('[type="submit"]');
      this.button = this.querySelector('button');
      if (!this.form || !this.main) { this.hidden = true; return; }
      this.onChange = event => {
        this.querySelector('[data-bar-price]').textContent = event.detail.price + (event.detail.frequency ? ' ' + event.detail.frequency : '');
        this.querySelector('[data-bar-selection]').textContent = event.detail.label;
        if (event.detail.cta) this.button.textContent = event.detail.cta;
      };
      this.form.addEventListener('evrayne:purchase-change', this.onChange);
      this.sync = () => { this.button.disabled = this.main.disabled || this.main.getAttribute('aria-disabled') === 'true'; };
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.main, { attributes: true, attributeFilter: ['disabled','aria-disabled'] });
      this.sync();
      this.mainVisible = true;
      this.footerVisible = false;
      this.updateVisibility = () => { this.hidden = this.mainVisible || this.footerVisible; };
      this.visibilityObserver = new IntersectionObserver(entries => { this.mainVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; this.updateVisibility(); }, { threshold: 0 });
      this.visibilityObserver.observe(this.main);
      const footer = document.querySelector('footer');
      if (footer) { this.footerObserver = new IntersectionObserver(entries => { this.footerVisible = entries[0].isIntersecting; this.updateVisibility(); }, { threshold: 0 }); this.footerObserver.observe(footer); }
      this.onResize = () => { this.style.visibility = window.visualViewport && window.visualViewport.height < window.innerHeight * 0.7 ? 'hidden' : ''; };
      window.visualViewport?.addEventListener('resize', this.onResize);
      this.form.querySelector('evrayne-purchase-options')?.updatePrice();
      this.form.querySelector('evrayne-integrated-purchase')?.updateChoice();
      this.closest('product-info')?.classList.add('ev-has-buy-bar');
    }
    disconnectedCallback() {
      this.form?.removeEventListener('evrayne:purchase-change', this.onChange);
      this.observer?.disconnect();
      this.visibilityObserver?.disconnect();
      this.footerObserver?.disconnect();
      window.visualViewport?.removeEventListener('resize', this.onResize);
    }
  });
}
